import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { Subscription, switchMap } from 'rxjs';
import { OrdersService } from '../../services/orders.service';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import {
  UpdateOrderWithInvoiceDto,
  UpdateOrderWithoutInvoiceDto,
} from 'src/app/domain/models/dto/update-order.dto';
import { CreateOrderConfirmComponent } from 'src/app/pages/orders/shared/components/create-order/create-order-confirm/create-order-confirm.component';
import { CreateOrderSuccessInboundComponent } from 'src/app/pages/orders/shared/components/create-order/create-order-success-inbound/create-order-success-inbound.component';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MerchantService } from 'src/app/core/merchant.service';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';

@Component({
  selector: 'app-update-order',
  templateUrl: './update-order.component.html',
  styleUrls: ['./update-order.component.scss'],
})
export class UpdateOrderComponent implements OnInit, OnDestroy {
  boobleModalData: InboundOrderDto;
  @Input() order: any;
  step = 1;
  finality: FinalitiesDto;
  hasDocumentStep = false;
  loading: boolean = false;
  updateOrderWithoutInvoice$?: Subscription;
  updateOrderWithInvoice$?: Subscription;
  isMobile = false;
  merchant: string = '';
  warrenGlobalOnly: boolean = false;

  constructor(
    private modalService: BoobleModalService,
    private orderService: OrdersService,
    private bottomSheet: MatBottomSheet,
    private merchantService: MerchantService,
    private tenantService: TenantGeneralService
  ) {}

  ngOnDestroy(): void {
    this.updateOrderWithoutInvoice$?.unsubscribe();
    this.updateOrderWithInvoice$?.unsubscribe();
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 820 ? true : false;
    this.merchant = this.merchantService.getUserMerchant();

    this.warrenGlobalOnly =
      this.merchant == this.tenantService.WARREN_GLOBAL_NAME;

    if (this.isMobile) {
      this.boobleModalData = this.order;
    }
  }

  closeModal() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.modalService.dismiss(null);
    }
  }

  goBackHandler() {
    this.step -= 1;
  }

  finalitySelectedHandler(event) {
    this.finality = event;

    if (this.finality.invoiceNeed === true && !this.warrenGlobalOnly) {
      this.hasDocumentStep = true;
      this.step += 1;
    } else {
      this.hasDocumentStep = false;

      const updateOrder = new UpdateOrderWithoutInvoiceDto();
      updateOrder.orderId = this.boobleModalData.id;
      updateOrder.finalityId = this.finality.id;

      this.updateOrder(updateOrder);
    }
  }

  updateOrder(event: UpdateOrderWithoutInvoiceDto) {
    this.loading = true;
    this.updateOrderWithoutInvoice$ = this.orderService
      .updateOrderWithoutInvoice(event)
      .subscribe({
        next: (res) => {
          if (this.isMobile) {
            this.bottomSheet.dismiss();
          }
          this.orderService.updateOrderView();
          this.modalService.present(CreateOrderSuccessInboundComponent, {
            order: res.data,
            analysisNeed: this.warrenGlobalOnly
              ? false
              : res.data.finality.analysisNeed,
          });
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  sendFileHandler(event: UpdateOrderWithInvoiceDto) {
    this.loading = true;
    event.finalityId = this.finality.id;
    event.orderId = this.boobleModalData.id;
    this.updateOrderWithInvoice$ = this.orderService
      .validateUploadInvoiceFileInbound(event)
      .pipe(
        switchMap((resultValidate) =>
          this.orderService.uploadInvoiceFileInbound(
            resultValidate.data.orderId,
            event
          )
        )
      )
      .subscribe({
        next: (res) => {
          this.orderService.updateOrderView();
          if (this.isMobile) {
            this.bottomSheet.dismiss();
          }
          this.modalService.present(CreateOrderSuccessInboundComponent, {
            order: res.data,
            analysisNeed: res.data.finality.analysisNeed,
          });
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }
}
